import React, { useState, useEffect } from 'react';
import { Button, Col, Container, Row } from "reactstrap";
import { Grid, _ } from 'gridjs-react';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';

import { useHistory } from 'react-router-dom';
import { deletePlaceMapPicture, getAllPlaceMapPictures } from '../../helpers/api/product/product';

const MapPictureTable = () => {
    const [mapPictures, setMapPictures] = useState([]);

    const history = useHistory();

    document.title = "Map Pictures";

    const getMapPictures = async () => {
        try {
            setMapPictures([]);

            let response = await getAllPlaceMapPictures();
            if (!response.success) throw response.data;

            setMapPictures(response.data.map(mapPicture => {
                return [
                    mapPicture.category,
                    mapPicture.name,
                    mapPicture.picture
                ]
            }));
        } catch (error) {
            console.log(error);
        }
    }

    const handleClickGridItem = (e) => {
        e.preventDefault();
        let row = e.target.parentElement.parentElement.parentElement;
        let name = row.children[1].innerText;
        let category = row.children[0].innerText;

        let item = mapPictures.find(mapPicture => mapPicture[1] === name && mapPicture[0] === category);
        history.push("/map-picture-details", { params: { category: item[0], name: item[1], image: item[2], type: "INFORM" } });
    }

    const handleClickDelete = async (e) => {
        try {
            e.preventDefault();

            confirmAlert({
                title: 'Confirm to Delete',
                message: 'Are you sure to delete this Map Picture?',
                buttons: [
                    {
                        label: 'Yes',
                        onClick: async () => {
                            let row = e.target.parentElement.parentElement.parentElement;
                            let name = row.children[1].innerText;
                            let category = row.children[0].innerText;

                            let item = mapPictures.find(mapPicture => mapPicture[1] === name && mapPicture[0] === category);

                            let response = await deletePlaceMapPicture({
                                category: item[0],
                                name: item[1],
                                photo: item[2]
                            });
                            if (!response.success) return console.log(response.data);

                            await getMapPictures();
                        }
                    },
                    {
                        label: 'No'
                    }
                ]
            });
        } catch (error) {
            console.log(error);
        }
    }

    useEffect(() => {
        getMapPictures();
    }, []);

    return (
        <>
            <div className="page-content">
                <Container fluid={true}>
                    <React.Fragment>
                        <Grid
                            data={mapPictures}
                            columns={[
                                "Category", "Name",
                                {
                                    name: 'Picture',
                                    width: '200px',
                                    formatter: (cell) => _(
                                        <>
                                            {(cell)
                                                ? <img src={cell} alt="mapPicture" style={{ height: "100px" }} />
                                                : <></>
                                            }
                                        </>
                                    )
                                },
                                {
                                    name: 'Actions',
                                    width: '120px',
                                    formatter: (cell) => _(
                                        <>
                                            <Button type='button' onClick={handleClickGridItem} className='btn btn-sm btn-light'> Details </Button>
                                            <Button type='button' onClick={handleClickDelete} className='btn btn-sm btn-danger'> Delete </Button>
                                        </>
                                    )
                                }
                            ]}
                            search={true}
                            sort={true}
                            pagination={{ enabled: true, limit: 25 }}
                        />
                    </React.Fragment>
                </Container>
            </div>
        </>
    );
}

export default MapPictureTable;